import {useQuery} from '@tanstack/react-query';
import ChessRestClient from '../../Api/ChessRestClient';

export function useGetChapterMoves(chapterId: number | string | undefined) {
  return useQuery(
    ['studyChapterMoves', chapterId],
    async () => {
      const response = await ChessRestClient.get(
        `/learning/study-chapter-moves/${chapterId}/`,
      );
      return response.data;
    },
    {
      enabled: !!chapterId,
      staleTime: 30_000,
    },
  );
}
